import AppContainer from "./AppContainer";
import PageLayout from "./pages";

// <AppMain /> - post-bootstrap "entry view" component
const AppMain = () => (
  <AppContainer>
    <PageLayout />
  </AppContainer>
);

export default AppMain;
